export default function ClientInformation({ paymentInfo }) {
    return (
      <div className="space-y-4">
        <h3 className="text-sm font-medium text-gray-700">Client Information(Payer)</h3>
  
        <div>
          <label className="block text-sm mb-1">Full Name</label>
          <input type="text" value={paymentInfo.clientName} readOnly className="w-full p-2 border rounded-md" />
        </div>
  
        <div>
          <label className="block text-sm mb-1">Application No.</label>
          <input type="text" value={paymentInfo.applicationNo} readOnly className="w-full p-2 border rounded-md" />
        </div>
  
        <div>
          <label className="block text-sm mb-1">Amount(auto-filled)</label>
          <input type="text" value={paymentInfo.amount} readOnly className="w-full p-2 border rounded-md" />
        </div>
      </div>
    )
  }
  
  